import React, { useEffect } from 'react';

import { GuestDamageProvider } from '@/context/GuestDamage/GuestDamageContext';
import { GuestDamageNegotiationProvider } from '@/context/GuestDamage/GuestDamageNegotiationsContext';
import { GuestDamageStepProvider } from '@/context/GuestDamage/GuestDamageStepContext';
import { ReservationsProvider } from '@/context/GuestDamage/ReservationsContext';

import GuestDamageFranchise from '@/components/GuestDamageFranchise/GuestDamageFranchise';

import { Container } from './styles';

const GuestDamageFranchisePage: React.FC = () => {
  useEffect(() => {
    document.title = 'Sapron | Danos de hóspede';
  }, []);

  return (
    <Container>
      <GuestDamageNegotiationProvider>
        <ReservationsProvider>
          <GuestDamageProvider>
            <GuestDamageStepProvider>
              <GuestDamageFranchise />
            </GuestDamageStepProvider>
          </GuestDamageProvider>
        </ReservationsProvider>
      </GuestDamageNegotiationProvider>
    </Container>
  );
};
export default GuestDamageFranchisePage;
